// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__QjR8R","contentWrap":"styles_contentWrap__ak7GP","rightColumnWrap":"styles_rightColumnWrap__AUuZJ","image":"styles_image__ypJQt"};